import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";
import { cn } from "@/lib/utils";

export type LiquidGlassVariant = "default" | "subtle" | "strong" | "pill" | "panel" | "nav";

const VARIANT_CLASS: Record<LiquidGlassVariant, string> = {
  default: "liquid-glass",
  subtle: "liquid-glass liquid-glass-subtle",
  strong: "liquid-glass liquid-glass-strong",
  pill: "liquid-glass liquid-glass-pill",
  panel: "liquid-glass liquid-glass-panel",
  nav: "liquid-glass-nav",
};

export function liquidGlass(variant: LiquidGlassVariant = "default", className?: string) {
  return cn(VARIANT_CLASS[variant], className);
}

type LiquidGlassProps<T extends ElementType> = {
  as?: T;
  variant?: LiquidGlassVariant;
  children?: ReactNode;
  className?: string;
} & Omit<ComponentPropsWithoutRef<T>, "as" | "children" | "className">;

export function LiquidGlass<T extends ElementType = "div">({
  as,
  variant = "default",
  className,
  children,
  ...props
}: LiquidGlassProps<T>) {
  const Component = as ?? "div";
  return (
    <Component className={liquidGlass(variant, className)} {...props}>
      {children}
    </Component>
  );
}
